import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router).mount('#app')

// Font Awesome 6 Icons + Vue 3.x
// Setup Instructions
// npm i --save @fortawesome/vue-fontawesome@prerelease (Vue 3.x)
// npm i --save @fortawesome/free-solid-svg-icons
// npm i --save @fortawesome/fontawesome-svg-core

import { library } from '@fortawesome/fontawesome-svg-core'
import { faDiamond, faSquare} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faDiamond, faSquare)

app.component('font-awesome-icon', FontAwesomeIcon)
app.config.productionTip = false

// Client side error logging
import HTTP from "./http-axios";
app.config.errorHandler = (err, instance, info) => {

    // handle error: report to server side controller for logging
    const errorMessage = ((err && err.message) || 'Unknown error') + ', Component: ' + (((instance && instance.$options && instance.$options.name) || 'AnonymousComponent')) + ', Info: ' + (info || 'None') + ',';

    //console.log(errorMessage);
    HTTP().post(`/api/error/vuejs?err=` + errorMessage)
}